module.exports = __webpack_public_path__ + "img/pvc_600g_farbauswahl_gelb_weiss.04ed61e7.jpg";